import React, { Component } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Meta, RatatoskRequest, RatatoskResponse, valueByFormikPath, valueNotEmpty } from '../../common'
import { Container, Grid, Message, Segment, Loader, Icon, Button as PButton, Modal, Dropdown, DropdownItem, DropdownMenu, Popup } from 'semantic-ui-react'
import { json } from 'stream/consumers'
import Form from '../form/Form'
import Input from '../form/Input'
import Checkbox from '../form/Checkbox'
import './CNCDictForm.css'
import { collectUpdates, delForm, makeGroupLink, response2groups, updateForm } from './CNCDictSublemma'
import { setFieldValue } from '../form/FormikHelpers'
import CNCDictBatchChange from './CNCDictBatchChange'
import CNCDictListSublemmas from './CNCDictListSublemmas'
import CNCDictFormItem from './CNCDictFormItem'
import Button from '../form/Button'
import CNCDictFormHomonyms from './CNCDictFormHomonyms'

interface CNCDictFormProps extends WithTranslation, RouteComponentProps {
    meta: Meta,
    http: AxiosInstance,
    form: string,
    units: any[],
    prefix: string,
    group: string,
    formik: any,
    setNewTag: (newTag: string) => void,
    batchDialogOpen: string|null,
    setBatchDialogOpen: (open: string|null) => void,
    setLemma: (formik, group, form, value) => void,
    setActive: (formik, group, form, value) => void,
    setDomain: (formik, group, form, domain, value) => void,
}

interface CNCDictFormState {
    extHomonyms: any[],
    extEdOpen: boolean,
    loading: boolean,
    errorMsg: string
}

/*const updateUnits = async (http, units: any[], initial: any[]) => {
    let errors = []
    for (let ui in units) {
        const u = units[ui]
        const orig = initial[ui]
        let res = null
        if (!u.active) {
            res = await delForm(http, u)
            if (res) errors.push(res)
            else continue
        } else {
            const updates = collectUpdates(u, orig)
            if (updates) {
                res = await updateForm(http, u, updates)
                if (res) errors.push(res)
            }
        }
    }
    return errors
}*/

class CNCDictForm extends Component<CNCDictFormProps, CNCDictFormState> {

    state = {
        extHomonyms: [] as any[],
        extEdOpen: false,
        loading: false,
        errorMsg: '',
        newTag: ''
    }

    componentDidMount() {
        const { prefix, form, units, formik } = this.props
        //this.componentDidUpdate(this.props, this.state)
        const sublemma = units[0].sublemma
        let request: RatatoskRequest = {
            query: {
                type: ':cncdict:form',
                feats: [
                    {type: ':form:attr:cnc:w:word', value: form, ci: true}
                ]
            },
            page: { from: 0, size: 1000 },
            feats: [':form:attr:cnc:w', ':form:cncdict:domain']
        }
        if (units.filter(x => x.id).length>0) {
            request.query.feats!.push({__not: {type: ':form:attr:cnc:w:sublemma', value: sublemma}})
        }
        this.setState({loading: true})
        const url = 'cunits/_view'
        this.props.http.post(url, request)
            .then(response => {
                const groups = response2groups(response.data.data)
                const units = Object.keys(groups).reduce((arr: any[], grp: string) => { 
                    groups[grp].forEach(u => arr.push(u))
                    return arr
                }, [])
                this.setState({extHomonyms: units, errorMsg: '', loading: false})
            }).catch(err => {
                this.setState({loading: false})
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message, loading: false})
                }
            })
    }

    componentDidUpdate(prevProps: Readonly<CNCDictFormProps>, prevState: Readonly<CNCDictFormState>, snapshot?: any): void {
        if (this.props.form!==prevProps.form)
            this.componentDidMount()
    }

    render() {
        const { prefix, group, formik, form, units, setNewTag, batchDialogOpen, setBatchDialogOpen, setActive, setDomain, setLemma, http, t } = this.props
        const { extHomonyms, loading, extEdOpen } = this.state

        /*const active = valueByFormikPath(prefix+'.active', formik.values)
        const form = valueByFormikPath(prefix+'.form', formik.values)
        const tag = valueByFormikPath(prefix+'.tag', formik.values)*/
        const groups = valueByFormikPath(prefix, formik.values)
        const sublemma = units[0].sublemma
        const otherGroups = Object.keys(groups).filter(a => a!==group)
        const innerHomonyms = otherGroups.reduce((res, grp) => {
            groups[grp].forEach(i => {if (i.form===form) res.push(i)} )
            return res
        }, [] as any[])
        /*const innerHomonyms = valueByFormikPath(prefix, formik.values).reduce((res, u) => {
            if (u.form===form && u.tag!==tag) res.push(u)
            return res
        }, [])*/

        const batchMessage = t("Set for all interpretations of form '{{form}}', sublemma '{{sublemma}}', lemma '{{lemma}}' ({{count}})", 
            {form: form, sublemma: sublemma, lemma: group, count: units.length})

        const extHomonymView = (
            <Segment className='ext-homonyms'>
                <ul>
                    {extHomonyms.map(u => (
                        <li><span className={"ext-homonym"+(u.domain.written||u.domain.spoken ? '' :  ' nodomain')}>
                            <NavLink to={makeGroupLink(u.sublemma, u.lemma, u.tag)}>{u.sublemma}\{u.lemma}</NavLink> {u.tag}
                        </span></li>
                    ))}
                </ul>
            </Segment>
        )

        return(
            <Segment className={units.filter(u =>u.active).length > 0 ? 'grey' : 'delete'}>
            <Modal open={batchDialogOpen===`${group}_${form}`} closeIcon={true} onClose={() => setBatchDialogOpen(null)}>
                <Modal.Content>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Message info header={t('Batch change')} content={batchMessage}/>
                            </Grid.Column>
                        </Grid.Row>
                        <CNCDictBatchChange {...this.props} formik={formik} group={group} form={form}
                            setDomain={setDomain} setLemma={setLemma} close={() => setBatchDialogOpen(null)}/>
                    </Grid>
                </Modal.Content>
            </Modal>
            <Modal open={extEdOpen} closeIcon={true} onClose={() => this.setState({extEdOpen: false})}>
                <Modal.Content>
                    <CNCDictFormHomonyms units={extHomonyms} http={http} close={(updated) => this.setState({extEdOpen: false, extHomonyms: updated})}/>
                </Modal.Content>
            </Modal>
            <Grid>
            {this.state.errorMsg ?
              (
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Message error icon='exclamation triangle' header={t('Error')} content={this.state.errorMsg}/>
                    </Grid.Column>
                </Grid.Row>
            ) : null}
            <Grid.Row verticalAlign='top'>
                <Grid.Column width={2}>
                    {form}
                </Grid.Column>
                <Grid.Column width={8}>
                    <Grid>
                    { units.length > 1 ?
                        <Grid.Row className='mcondensed control'>
                        <Grid.Column width={6}>
                            { units.filter(u =>u.active).length > 0 ?
                                <Button type="button" icon="delete" size="mini" color="red" className="checkbox-size"
                                    onClick={()=> setActive(formik, group, form, false)}/> 
                            : 
                                <Button type="button" icon="undo" size="mini" color="yellow" className="checkbox-size"
                                    onClick={()=> setActive(formik, group, form, true)}/>
                            }
                        </Grid.Column>
                        <Grid.Column width={3}>
                            { units.filter(u =>u.domain.written).length > 0 ?
                                <Button type="button" icon="delete" size="mini" color="orange" className="checkbox-size super"
                                    onClick={()=> setDomain(formik, group, form, 'written', false)}/>
                            :
                                <Button type="button" icon="check" size="mini" color="blue" className="checkbox-size super"
                                    onClick={()=> setDomain(formik, group, form, 'written', true)}/>
                            }
                        </Grid.Column>
                        <Grid.Column width={3}>
                            { units.filter(u =>u.domain.spoken).length > 0 ?
                                <Button type="button" icon="delete" size="mini" color="orange" className="checkbox-size super"
                                    onClick={()=> setDomain(formik, group, form, 'spoken', false)}/>
                            :
                                <Button type="button" icon="check" size="mini" color="blue" className="checkbox-size super"
                                    onClick={()=> setDomain(formik, group, form, 'spoken', true)}/>
                            }
                        </Grid.Column>
                        <Grid.Column width={4}>
                        </Grid.Column>
                        </Grid.Row>
                    : null }
                    { units.map(u => {
                        const myprefix = prefix+'.'+group+'.'+u.index
                        return(<CNCDictFormItem formik={formik} unit={u} prefix={myprefix} setNewTag={setNewTag}/>)
                    })
                    }
                    </Grid>
                </Grid.Column>
                <Grid.Column width={5}>
                    { innerHomonyms.length ? (
                        <Segment className='inner-homonyms'>
                        <ul>
                            {innerHomonyms.map(u => (
                                <li><span className="inner-homonym"><NavLink to={makeGroupLink(u.sublemma, u.lemma, u.tag)}>{u.sublemma}\{u.lemma}</NavLink> {u.tag}</span></li>
                            ))}
                        </ul>
                        </Segment>
                    ) : null}
                    { loading ? (<Loader active inline/>) 
                    : extHomonyms.length ? (
                        <Popup basic hoverable position='top right' offset={[-5,-60]} on="hover" trigger={extHomonymView} size="mini">
                          <Button type="button" color="blue" icon="edit" size="mini" onClick={() => this.setState({extEdOpen: true})}/>
                        </Popup>
                    ) : null}
                </Grid.Column>
                <Grid.Column width={1}>
                    <Button type="button" color="blue" icon="edit" size="mini" onClick={() => setBatchDialogOpen(`${group}_${form}`)} />
                </Grid.Column>
            </Grid.Row>
            </Grid>
            </Segment>
        )
    }

}

export default withTranslation()(CNCDictForm)